export default {
  descriptionColor: Styles.color.grey.one,
  headingTextTransform: Styles.textTransform.headlines,
};
